// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderLetter,
    ProviderLetterSortType,
    SupportCreateLetterPayload,
    SupportLetter,
    SupportLetterSortType,
    TemporaryDocumentUrl,
    SupportCreateLetterPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderLetterFromJSON,
    SupportLetterFromJSON,
    TemporaryDocumentUrlFromJSON,
} from '../models';

export interface CancelLetterRequestRequest {
    id: string;
}

export interface CreateSupportLetterRequest {
    supportCreateLetterPayload: SupportCreateLetterPayload;
}

export interface GetProviderLetterRequest {
    id: string;
}

export interface GetSupportLetterRequest {
    id: string;
}

export interface ListProviderLettersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderLettersOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterDocumentType?: Array<string>;
    sort?: Array<ProviderLetterSortType>;
}

export interface ListSupportLettersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportLettersOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterDocumentType?: Array<string>;
    sort?: Array<SupportLetterSortType>;
}

export interface ViewProviderLetterRequest {
    id: string;
}

export interface ViewSupportLetterRequest {
    id: string;
}

/**
 * no description
 */
export class LetterApi extends runtime.BaseAPI {

    /**
     * Cancel a document request.
     * Cancel a letter request
     */
    async cancelLetterRequestRaw(requestParameters: CancelLetterRequestRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling cancelLetterRequest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:letter", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/letter/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Cancel a document request.
     * Cancel a letter request
     */
    async cancelLetterRequest(requestParameters: CancelLetterRequestRequest): Promise<ObjectNoResponse> {
        const response = await this.cancelLetterRequestRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create and send a letter in the mail.
     * Create a letter
     */
    async createSupportLetterRaw(requestParameters: CreateSupportLetterRequest): Promise<runtime.ApiResponse<SupportLetter>> {
        if (requestParameters['supportCreateLetterPayload'] === null || requestParameters['supportCreateLetterPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateLetterPayload','Required parameter requestParameters.supportCreateLetterPayload was null or undefined when calling createSupportLetter.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:letter", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/letter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateLetterPayloadToJSON(requestParameters['supportCreateLetterPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportLetterFromJSON(jsonValue));
    }

    /**
     * Create and send a letter in the mail.
     * Create a letter
     */
    async createSupportLetter(requestParameters: CreateSupportLetterRequest): Promise<SupportLetter> {
        const response = await this.createSupportLetterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a letter
     * Get a letter
     */
    async getProviderLetterRaw(requestParameters: GetProviderLetterRequest): Promise<runtime.ApiResponse<ProviderLetter>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderLetter.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:letter"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/letter/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderLetterFromJSON(jsonValue));
    }

    /**
     * Get a letter
     * Get a letter
     */
    async getProviderLetter(requestParameters: GetProviderLetterRequest): Promise<ProviderLetter> {
        const response = await this.getProviderLetterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a letter
     * Get a letter
     */
    async getSupportLetterRaw(requestParameters: GetSupportLetterRequest): Promise<runtime.ApiResponse<SupportLetter>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportLetter.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:letter", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/letter/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportLetterFromJSON(jsonValue));
    }

    /**
     * Get a letter
     * Get a letter
     */
    async getSupportLetter(requestParameters: GetSupportLetterRequest): Promise<SupportLetter> {
        const response = await this.getSupportLetterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of letters
     * Get a list of letters
     */
    async listProviderLettersRaw(requestParameters: ListProviderLettersRequest): Promise<runtime.ApiResponse<Array<ProviderLetter>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterDocumentType) {
            queryParameters['filterDocumentType'] = requestParameters.filterDocumentType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:letter"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/letter`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderLetterFromJSON));
    }

    /**
     * Gets a list of letters
     * Get a list of letters
     */
    async listProviderLetters(requestParameters: ListProviderLettersRequest): Promise<Array<ProviderLetter>> {
        const response = await this.listProviderLettersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of letters
     * Get a list of letters
     */
    async listSupportLettersRaw(requestParameters: ListSupportLettersRequest): Promise<runtime.ApiResponse<Array<SupportLetter>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterDocumentType) {
            queryParameters['filterDocumentType'] = requestParameters.filterDocumentType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:letter", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/letter`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportLetterFromJSON));
    }

    /**
     * Gets a list of letters
     * Get a list of letters
     */
    async listSupportLetters(requestParameters: ListSupportLettersRequest): Promise<Array<SupportLetter>> {
        const response = await this.listSupportLettersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a letter\'s url
     * Get a letter\'s url
     */
    async viewProviderLetterRaw(requestParameters: ViewProviderLetterRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewProviderLetter.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/letter/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a letter\'s url
     * Get a letter\'s url
     */
    async viewProviderLetter(requestParameters: ViewProviderLetterRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewProviderLetterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a letter\'s url
     * Get a letter\'s url
     */
    async viewSupportLetterRaw(requestParameters: ViewSupportLetterRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportLetter.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/letter/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a letter\'s url
     * Get a letter\'s url
     */
    async viewSupportLetter(requestParameters: ViewSupportLetterRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportLetterRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderLettersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportLettersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
